import { Helpers } from '../../helpers';
import { IConstraintSpudLimit } from '../../interfaces/iconstraint-spud-limit';
import { AreaType } from '../area-type';
import { ConstraintSpudLimitDetail } from '../constraint-spud-limit-detail';
import { Scenario } from '../scenario';

export class ConstraintSpudLimitBase {
  ConstraintSpudLimitId: number;
  ScenarioId: number;
  AreaTypeId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintSpudLimitDetails_ConstraintSpudLimit?: Array<ConstraintSpudLimitDetail> | null;
  AreaType?: AreaType;
  Scenario?: Scenario;

  constructor(item?: IConstraintSpudLimit) {
    if (item) {

      this.ConstraintSpudLimitId = item.ConstraintSpudLimitId;
      this.ScenarioId = item.ScenarioId;
      this.AreaTypeId = item.AreaTypeId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintSpudLimitDetails_ConstraintSpudLimit = Helpers.createClassArray(ConstraintSpudLimitDetail, item.ConstraintSpudLimitDetails_ConstraintSpudLimit);
      this.AreaType = new AreaType(item.AreaType);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}